import { render, staticRenderFns } from "./ESGButton.vue?vue&type=template&id=1158fbfa&scoped=true"
import script from "./ESGButton.vue?vue&type=script&lang=js"
export * from "./ESGButton.vue?vue&type=script&lang=js"
import style0 from "./ESGButton.vue?vue&type=style&index=0&id=1158fbfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1158fbfa",
  null
  
)

export default component.exports